import styled from '@emotion/styled';
import Confetti from 'react-confetti';
import { withConfig } from 'src/utils/withConfig';

interface LinkItemType {
    imgSrc: string
}

export const ModalWrapper = styled('div', { label: 'ModalWrapper' })`
    + header {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
    }
`;

export const Wrapper = withConfig(theme => styled('div', { label: 'Wrapper' })`
    width: 100%;
    height: 40%;
    padding: 44px 48px;
    border-radius: 10px;
    background-image: linear-gradient(180deg, ${theme.anniversaryModal.bgColor}, ${theme.anniversaryModal.bgColorSecondary});
`);

export const ImageWrapper = styled('div', { label: 'ImageWrapper' })<LinkItemType>`
    width: 240px;
    height: 148px;
    margin: 0 auto;
    background-image: ${(props): string => `url(${props.imgSrc})`};
    background-size: cover;
`;

export const ConfettiCanvas = styled(Confetti, { label: 'ConfettiCanvas' })`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed !important;
    width: 100vw;
    height: calc(100vh - 56px);
    top: 0;
    left: 0;
    top: 56px !important;
    z-index: 3!important;
    background-color: rgba(0, 0, 0, 0.95);
    cursor: pointer;
`;

export const HappyAniversary = withConfig(theme => styled('div', { label: 'HappyAniversary' })`
    font-size: 26px;
    line-height: 1.26;
    font-weight: 700;
    color: ${theme.anniversaryModal.txtColor};
`);

export const DetailsWrapper = styled('div', { label: 'DetailsWrapper' })`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Description = withConfig(theme => styled('div', { label: 'Description' })`
    font-size: 20px;
    line-height: 1.3;
    font-weight: 700;
    max-width: 300px;
    text-align: center;
    color: ${theme.anniversaryModal.txtColorSecondary};
    margin: 10px 0 25px 0;
`);

export const AnniversaryButton = withConfig(theme => styled('div', { label: 'AnniversaryButton' })`
    cursor: pointer;
    background-color: ${theme.anniversaryModal.bgColorTertiary};
    padding: 0 81px;
    box-shadow: 0px 16px 12px rgba(0, 0, 0, 0.24);
    border-radius: 4px;
    height: 52px;
`);

export const ButtonTitle = withConfig(theme => styled('div', { label: 'ButtonTitle' })`
    font-size: 18px;
    line-height: 1.29%;
    color: ${theme.anniversaryModal.txtColorTertiary};
    padding-top: 26px;
    font-weight: 700;
`);
